import React from 'react';
import NavBar from '../../components/Navbar/NavBar';
import FooterOne from '../../components/Footer/Footer';
import { Box, Grid, Card, CardActionArea, CardContent, CardMedia, Container, Typography, useTheme, useMediaQuery } from '@mui/material';
import { directorsData } from '../../utils/BeadsData';

const BoardDirectors = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    // const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    const cardStyle = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        textAlign: isMobile ? 'center' : 'left',
        padding: isMobile ? theme.spacing(1) : theme.spacing(2),
        transition: 'transform 0.5s ease',
        '&:hover': {
            transform: 'scale(1.05)',
        },
        margin: isMobile ? theme.spacing(1) : theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.divider}`,
    };

    const imageStyle = {
        height: isDesktop ? 200 : 140,
        width: isDesktop ? 200 : 140,
        borderRadius: '50%',
        objectFit: 'cover',
        flexShrink: 0,
        marginRight: isDesktop ? theme.spacing(4) : 0,
    };

    const contentStyle = {
        flexGrow: 1, // Allows the content to grow and fill the space
    };

    // Helper function to render description with line breaks
    const renderDescriptionWithLineBreaks = (description) => {
        return description.split('<br />').map((line, index) => (
            <Typography key={index} variant="body1" sx={{ mt: index === 0 ? 1 : 0.5 }} color="text.secondary">
                {line}
            </Typography>
        ));
    };

    return (
        <Box>
            <NavBar />
            <Container sx={{ mt: 10, mb: 5 }}>
                <Typography variant="h3" sx={{ my: 5, textAlign: 'center' }}>
                    Board of Directors
                </Typography>

                <Grid container spacing={isMobile ? 1 : 4}>
                    {directorsData.map((director, index) => {
                        const isKenyaBoardMemberStart = index === 8;

                        return (
                            <React.Fragment>
                                {isKenyaBoardMemberStart && (
                                    <Grid item xs={12} key="kenyan-board-members">
                                        <Typography variant="h4" sx={{ my: 2, textAlign: 'center', color: 'black' }}>
                                            Kenya Board Members
                                        </Typography>
                                    </Grid>
                                )}
                                <Grid item xs={12} md={12} key={index}>
                                    <Card sx={cardStyle}>
                                        <CardActionArea sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row' }}>
                                            <CardMedia
                                                component="img"
                                                image={director.image}
                                                alt={director.alt}
                                                sx={imageStyle}
                                            />
                                            <CardContent sx={contentStyle}>
                                                <Typography gutterBottom variant="h5">
                                                    {director.name}
                                                </Typography>
                                                {director.role && (
                                                    <Typography variant="body2" color="text.secondary" fontWeight={'bold'}>
                                                        {director.role}
                                                    </Typography>
                                                )}
                                                {renderDescriptionWithLineBreaks(director.description)}
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            </React.Fragment>
                        );
                    })}
                </Grid>
            </Container>
            <FooterOne />
        </Box>
    );
};

export default BoardDirectors;
